import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-share-div',
  templateUrl: './share-div.component.html',
  styleUrls: ['./share-div.component.css']
})
export class ShareDivComponent implements OnInit {

  @Input() dataToShare;
  @Input() dataType;
  // @Input() searchTermDoctorOne;
  @Output() clickAction = new EventEmitter();
  searchTermDoctor:string ='';

  constructor() { }

  ngOnInit() {
  }

  share(data) {
    this.clickAction.emit(data);

  }

}
